import * as React from 'react'
import RiderSearch from '../../containers/trips/RiderSearch'
import TripZoneSelector from '../../containers/trips/TripZoneSelector'
import StationUserTripsDashboard from '../../containers/station-user-trips/StationUserTripsDashboard'
import Swap from 'src/components/icons/trips/Swap'
export interface ITrips {
  location: any
  value: string
  setCurrentTripStage: () => void
  showOrgServiceArea: () => void
}

const StationUserTrips = (props: ITrips) => {
  // props.setCurrentTripStage()
  return (
    <React.Fragment>
      <RiderSearch />
      {!props.value && <StationUserTripsDashboard {...props} />}
    </React.Fragment>
  )
}

export default StationUserTrips



// WEBPACK FOOTER //
// ./src/components/station-user-trips/StationUserTrips.tsx